import React from 'react';
import { useTripContext } from '../contexts/TripContext';
import HeroSection from '../components/landing/HeroSection';
import SearchBox from '../components/landing/SearchBox';
import TripFilters from '../components/landing/TripFilters';
import PopularDestinations from '../components/landing/PopularDestinations';
import './LandingView.css';

/**
 * LandingView - Main landing page content (without navbar - now in AppShell)
 * Displays hero section, search box, filters, and popular destinations
 */
const LandingView = () => {
  const { departureCity, goToChatWithQuery } = useTripContext();

  return (
    <div className="landing-content">
      {/* Hero Section with Departure Selector */}
      <HeroSection />

      {/* Search Box with AI Suggestions */}
      <SearchBox />

      {/* Trip Filters */}
      <TripFilters />

      {/* DBS Travel Card Offers entry section */}
      <div className="landing-offers-section">
        <h2 className="landing-offers-title">DBS Travel Card Offers</h2>
        <p className="landing-offers-subtitle">
          View all DBS/POSB travel card privileges in one place, and filter by card or merchant.
        </p>
        <button
          className="landing-offers-button"
          onClick={() => {
            // For now open in a new tab; later you can integrate into router/TripContext views
            window.open('/offers', '_blank');
          }}
        >
          View Travel Card Offers
        </button>
      </div>

      {/* Popular Destinations */}
      <PopularDestinations />
    </div>
  );
};

export default LandingView;
